import gql from 'graphql-tag'

export const fetchOrganizationsList = () => {
	return {
		query: gql`
			{
				organizations: organizations(order_by: { name: asc }) {
					id
					name
					country {
						code
					}
					contact_name
					contact_email
					contact_phone
					active
				}
			}
		`,
		update: data =>
			data.organizations.map(item => ({
				id: item.id,
				name: item.name,
				country: item.country.code,
				contact_name: item.contact_name,
				contact_email: item.contact_email,
				contact_phone: item.contact_phone,
				edit: true,
				active: item.active
			}))
	}
}
